import { render, staticRenderFns } from "./localVideo.vue?vue&type=template&id=72352f6e&scoped=true&"
import script from "./localVideo.vue?vue&type=script&lang=js&"
export * from "./localVideo.vue?vue&type=script&lang=js&"
import style0 from "./localVideo.vue?vue&type=style&index=0&id=72352f6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72352f6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('72352f6e')) {
      api.createRecord('72352f6e', component.options)
    } else {
      api.reload('72352f6e', component.options)
    }
    module.hot.accept("./localVideo.vue?vue&type=template&id=72352f6e&scoped=true&", function () {
      api.rerender('72352f6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/localVideo.vue"
export default component.exports